/* istanbul ignore file */
/* eslint-disable */
import classNames from "classnames";
import { bedragFormat } from "../../../../shared/utils/currency";
import { ControleMaandlastOptions } from "./utils";

const monthDivisionFactor = 12;

export enum ScenarioType {
  Arbeidsongeschiktheid = "Arbeidsongeschiktheid",
  Werkloosheid = "Werkloosheid",
  Overlijden = "Overlijden",
  Pensioen = "Pensioen",
}

export const bedragFormatNull = (
  bedrag: number | null | undefined,
  op: (input: number) => number | undefined = (input: number) => input,
  decimals: number = 0,
  abs: boolean = false
): string => {
  if (bedrag === null || bedrag === undefined) {
    return bedragFormat(0, decimals);
  }

  let processedBedrag = bedrag;

  if (abs && bedrag < 0) {
    processedBedrag = Math.abs(Math.min(bedrag, 0));
  } else if (abs) {
    processedBedrag = Math.abs(bedrag);
  }

  if (op) {
    processedBedrag = op(processedBedrag) || 0;
  }

  return bedragFormat(processedBedrag, decimals);
};

export const monthDivision = (x: number): number =>
  x > 0 ? x / monthDivisionFactor : x;

export const getConclusieArcering = (conclusie: string) => {
  const lowerCaseConclusion = conclusie?.toLowerCase();
  return classNames({
    "table-warning": lowerCaseConclusion === "passend",
    "table-success": lowerCaseConclusion === "verantwoord",
    "table-danger": lowerCaseConclusion === "overschrijdt",
  });
};

export const getTrArcering = (tekort: boolean) => {
  return classNames({
    "table-danger": tekort,
    "table-success": !tekort,
  });
};

export const getKlantIdRequired = (
  soort: ScenarioType,
  selectedKlantId: string
) => {
  if (
    soort === ScenarioType.Arbeidsongeschiktheid ||
    soort === ScenarioType.Werkloosheid
  )
    return false;
  return !!selectedKlantId;
};

export const getMaandlastKeuzeTekst = (
  keuze: ControleMaandlastOptions | null
): string => {
  if (keuze === ControleMaandlastOptions.BenodigdInkomen) return "inkomensnorm";
  if (keuze === ControleMaandlastOptions.WerkelijkeLast) return "hypotheeknorm";
  return "controle-maandlastkeuze-onbekend";
};

export const getMonthlyAmount = (
  annualAmount: number | null | undefined
): number | null => {
  if (annualAmount == null) return null;

  return annualAmount / monthDivisionFactor;
};
